import { createRouter, createWebHistory } from 'vue-router';
import { useContextStore } from '@/Stores/context';

const BasicLayout = () => import('@/Layouts/BasicLayout.vue');
const DetailLayout = () => import('@/Layouts/DetailLayout.vue');
const EmptyLayout = () => import('@/Layouts/EmptyLayout.vue');
const PortalPage = () => import('@/Templates/Views/Portal/PortalPage.vue');
const ResultListPage = () => import('@/Templates/Views/ResultList/ResultListPage.vue');
const FinderMapPage = () => import('@/Templates/Views/ResultList/FinderMap/FinderMapPage.vue');
const BookmarkPage = () => import('@/Templates/Views/Collection/Bookmark/BookmarkPage.vue');
const WidgetBuilderPage = () => import('@/Templates/Views/WidgetBuilder/WidgetBuilderPage.vue');
const DetailBuilderPage = () => import('@/Templates/Views/DetailBuilder/DetailBuilderPage.vue');
const ChatPage = () => import('@/Templates/Views/Chat/ChatPage.vue');
const DayPlannerPage = () => import('@/Templates/Views/DayPlanner/DayPlannerPage.vue');
const DetailPage = () => import('@/Templates/Views/Detail/DetailPage.vue');
const NotFound = () => import('@/Templates/Views/404NotFound.vue');

const router = createRouter({
  history: createWebHistory('/'),
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.name && to.name === _from.name) {
      return false;
    }

    if (to.hash) {
      return { el: to.hash, top: 0 };
    }

    return { left: 0, top: 0 };
  },
  routes: [
    {
      path: '/:language/:experience/:template',
      component: BasicLayout,
      children: [
        { path: '', redirect: { name: 'Portal' } },
        { path: 'portal/:pathMatch(.*)*', name: 'Portal', component: PortalPage },
        { path: 'search/:dataType/:filters(.*)*', name: 'ResultList', component: ResultListPage },
        { path: 'finder/:dataType/:filters(.*)*', name: 'FinderMap', component: FinderMapPage },
        { path: 'collection/bookmarks', name: 'Bookmarks', component: BookmarkPage },
        { path: 'widget-builder', name: 'WidgetBuilder', component: WidgetBuilderPage },
        { path: 'dayplanner/:filters(.*)*', name: 'DayPlanner', component: DayPlannerPage },
      ],
    },
    {
      path: '/:language/:experience/:template/chat',
      component: EmptyLayout,
      children: [{ path: '', name: 'Chat', component: ChatPage }],
    },
    {
      path: '/:language/:experience/:template/detail-builder',
      component: EmptyLayout,
      children: [{ path: '', name: 'DetailBuilder', component: DetailBuilderPage }],
    },
    {
      path: '/:language/:experience/:template/detail',
      component: DetailLayout,
      children: [{ path: ':type/:id/:title?', name: 'Detail', component: DetailPage, props: true }],
    },
    {
      path: '/:catchAll(.*)*',
      component: EmptyLayout,
      children: [
        {
          path: '',
          name: 'NotFound',
          component: NotFound,
          props: (route) => ({
            title: typeof route.query.title === 'string' ? route.query.title : undefined,
            subtitle: typeof route.query.subtitle === 'string' ? route.query.subtitle : undefined,
            back: typeof route.query.back === 'string' ? route.query.back : undefined,
          }),
        },
      ],
    },
  ],
});

router.beforeEach((to) => {
  useContextStore().updateFromRoute(to);
});

export default router;
